export const rules = function () {
    return {
      cashRebate: [
        { required: true, message: '请输入费用政策', trigger: ['blur', 'change'] },
      ],
      cusRebate: [
        { required: true, message: '请选择审核结果', trigger: ['blur', 'change'] },
      ],
	  lakala_amount: [
	    { required: true, message: '请输入拉卡拉收款数量', trigger: ['blur', 'change'] },
	  ],
	  qywx_amount: [
	    { required: true, message: '请输入企业微信收款数量', trigger: ['blur', 'change'] },
	  ],
      wx_qrcode_amount: [
        { required: true, message: '请输入微信收款数量', trigger: ['blur', 'change'] },
      ],
      gh_qrcode_amount: [
        { required: true, message: '请输入公户收款数量', trigger: ['blur', 'change'] },
      ],
      gh_amount: [
        { required: true, message: '请输入公户收款数量', trigger: ['blur', 'change'] },
      ],
      other_amount: [
        { required: true, message: '请输入其他收款数量', trigger: ['blur', 'change'] },
      ],
      payTime: [
        { required: true, message: '请输入支付时间', trigger: ['blur', 'change'] },
      ],
      // plan_template: [
      //   { required: true, message: '请选择内保公司', trigger: ['blur', 'change'] },
      // ],
    }
}

export default {}